import { FETCH_BANNER } from "../actions/types";

export const bannerReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_BANNER:
      return action.payload;
    default:
      return state;
  }
};
